import React, {StrictMode} from "react";
import ReactDOM from "react-dom/client";
import App from './App';
import "./App.css";
import { ReactKeycloakProvider } from '@react-keycloak/web';
import * as serviceWorker from './serviceWorkerRegistration';
import './i18n';
import Keycloak from 'keycloak-js';
import {fas} from "@fortawesome/free-solid-svg-icons";
import {fab} from "@fortawesome/free-brands-svg-icons";
import {far} from "@fortawesome/free-regular-svg-icons";
import {library} from "@fortawesome/fontawesome-svg-core";

const k = new Keycloak({
    realm: 'adegroup',
    url: 'https://sso.firstsoftwaresolutions.com/',
    clientId: 'ade-hazmat'
});
library.add(far,fab,fas)
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    // <StrictMode>
        <ReactKeycloakProvider
            authClient={k}
            initOptions={{
                useNonce: false,
                onLoad: "login-required",
                // onLoad: 'check-sso',
                //
                // redirectUri: window.origin,
                // pkceMethod: 'S256',
                // checkLoginIframe: true,
                // responseMode: undefined,
                scope: "openid profile email"
            }}
        >
            <StrictMode>
                <App />
            </StrictMode>
        </ReactKeycloakProvider>
// </StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()